export default {
  namespaced: true,
  state: {
    /** 全部培训 */
    allTrain: null,
    /** 搜索培训 */
    searchTrain: null,
    /** 搜索关键字 */
    keyword: null,
    /** 类型 */
    filterType: null,
    /** 类型列表 */
    typeList: [],
    /** 省份 */
    filterProvince: null,
    /** 省份列表 */
    provinceList: [],
  },
  mutations: {
    SET_ALL_TRAIN(state, payload) {
      state.allTrain = payload;
    },
    SET_SEARCH_TRAIN(state, payload) {
      state.searchTrain = payload;
    },
    SET_KEYWORD(state, payload) {
      state.keyword = payload;
    },
    SET_FILTER_TYPE(state, payload) {
      state.filterType = payload;
    },
    SET_TYPE_LIST(state, payload) {
      state.typeList = payload;
    },
    SET_FILTER_PROVINCE(state, payload) {
      state.filterProvince = payload;
    },
    SET_PROVINCE_LIST(state, payload) {
      state.provinceList = payload;
    },
  },
};
